<template>
  <div class="as-player-v2">
    <div :class="'as-player-v2-item as-player-v2-item__' + _class">
      <div :class="'as-player-v2-item__img ' + _class">
        <img :src="img || getImgUrlBySport('player', '4wyrn1tvowkq86p', true, 'basketball')" class="as-player-v2-item__player" />
        <div v-if="country" :class="'as-player-v2-item__country ' + _class">
          <span class="as__max-point">{{ scores }}</span>
          <div class="as-div__country">
            <img :src="country || getImgUrlBySport('team', 'gy0or5jhdwxqwzv', true, 'football')" class="as__country" />
          </div>
        </div>
      </div>
      <div :class="`as-player-v2-item__name as-player-v2-item__name-${_class}`">
        {{ name }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
interface IProps {
  name: string;
  scores: string;
  img?: string;
  country?: string;
  mode?: string;
  _class?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  name: "Alex Toohey",
  scores: "20",
  mode: "tennis",
  _class: "home",
});
</script>

<script lang="ts">
export default {};
</script>
